module.exports = __webpack_public_path__ + "img/Residential bungalow -Gadhinglaj.820ea509.jpg";